module.exports = __webpack_public_path__ + "img/columns.a3c56766.svg";